import './App.css';

import Home from './pages/Home';
import { HashRouter, Routes, Link, Route } from 'react-router-dom'; 
import {api_base_url} from './common/Constants';

import About from './pages/About';
import TermsOfUse from './pages/TermsOfUse';
import RefundPolicy from './pages/RefundPolicy';
import OurCompanies from './pages/OurCompanies';
import Shop from './pages/Shop';
import Search from './pages/Search';
import Careers from './pages/Careers';
import Gallery from './pages/Gallery';
import Blog from './pages/Blog';
import BlogInfo from './pages/BlogInfo';
import Contact from './pages/Contact';
import Products from './pages/Products';
import Checkout from './pages/Checkout';
import MakePayment from './pages/MakePayment';
import Cart from './pages/Cart';
import Success from './pages/Success';
import ConfirmOrder from './pages/ConfirmOrder';
import ConfirmPayment from './pages/confirmPayment';
import UserRegister from './user/UserRegister';
import UserLogin from './user/UserLogin';
import UserProfile from './user/UserProfile';
import UserOrders from './user/UserOrders';
import UserViewOrder from './user/UserViewOrder';
import UserEditProfile from './user/UserEditProfile';
import UserChangePassword from './user/UserChangePassword';
import UserConfirm from './user/UserConfirm';
import UserReset from './user/UserReset';
import UserForgot from './user/UserForgot';
import { SharedProvider } from './pages/createContext';
import  MapClassComponent  from './pages/location.js';
import  LocationMap  from './pages/LocationMap';
import React, { useEffect, useState } from 'react';
import { base_url} from './common/Constants'; 



function App() {

   const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        
        const res = await fetch(api_base_url+"get-home-data", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: localStorage.getItem('user_id'),
           
          }),
        });
        const data = await res.json();
 
         
            localStorage.setItem('delivery_charges',parseFloat(data.settings.site_delivery_charges)) ;
            localStorage.setItem("settings", JSON.stringify(data.settings));
            localStorage.setItem("banners", JSON.stringify(data.banners));
            localStorage.setItem("categories", JSON.stringify(data.categories));
            localStorage.setItem("products", JSON.stringify(data.products));
            localStorage.setItem("popularProducts", JSON.stringify(data.popular_products));
            localStorage.setItem("offerProducts", JSON.stringify(data.offer_products));
            localStorage.setItem("cart", JSON.stringify(data.cart));
            localStorage.setItem("user", JSON.stringify(data.user));
            localStorage.setItem("blogs", JSON.stringify(data.blogs));
            localStorage.setItem("page_content", JSON.stringify(data.page_content));
            localStorage.setItem("content", JSON.stringify(data.content));
            const script = document.createElement("script");

            script.src   = base_url+"assets/js/loadHead.js";  
            script.async = true;
            document.body.appendChild(script);

            script.onload = () => {
            if (window.loadOnHead) {
        
            window.loadOnHead();
             setLoading(false);
            }
            };
       
      } catch (err) {
        console.error(err);
      }
    };
  
    fetchSettings();
  }, []);
  
   
  if (loading) return <div class="loader">Loading...</div>;
 
  return (
    <div> 
      <SharedProvider>
      <HashRouter>
      
      <Routes>
        <Route  path="/" element={<Home />} > </Route>
        <Route  path="/about-us" element={<About />} > </Route> 
        <Route  path="/terms-of-use" element={<TermsOfUse />} > </Route> 
        <Route  path="/refund-policy" element={<RefundPolicy />} > </Route> 
        <Route  path="/our-companies" element={<OurCompanies />} > </Route> 
        <Route  path="/shop" element={<Shop />} > </Route> 
        <Route  path="/search/:id/:word" element={<Search />} > </Route> 
        <Route  path="/search/:id" element={<Search />} > </Route> 
        <Route  path="/careers" element={<Careers />} > </Route> 
        <Route  path="/gallery" element={<Gallery />} > </Route> 
        <Route  path="/blog" element={<Blog />} > </Route> 
        <Route  path="/blog-info/:id" element={<BlogInfo />} > </Route> 
        <Route  path="/category/:id" element={<Shop />} > </Route> 
        <Route  path="/products/:id" element={<Products />} > </Route> 
        <Route  path="/contact-us" element={<Contact />} > </Route> 
        <Route  path="/cart" element={<Cart />} > </Route> 
        <Route  path="/checkout" element={<Checkout />} > </Route> 
        <Route  path="/success" element={<Success />} > </Route> 
        <Route  path="/make-payment" element={<MakePayment />} > </Route> 
        <Route  path="/confirm" element={<ConfirmOrder />} > </Route> 
        <Route  path="/ConfirmPayment" element={<ConfirmPayment />} > </Route> 
        <Route  path="/user/register" element={<UserRegister />} > </Route> 
        <Route  path="/user/login" element={<UserLogin />} > </Route> 
        <Route  path="/user/forgot-password" element={<UserForgot />} > </Route> 
        <Route  path="/user/profile" element={<UserProfile />} > </Route> 
        <Route  path="/user/orders" element={<UserOrders />} > </Route> 
        <Route  path="/user/view-order/:id" element={<UserViewOrder />} > </Route> 
        <Route  path="/user/edit" element={<UserEditProfile />} > </Route> 
        <Route  path="/user/change-password" element={<UserChangePassword />} > </Route> 
        <Route  path="/user/confirm/:token" element={<UserConfirm />} > </Route> 
        <Route  path="/user/reset/:token" element={<UserReset />} > </Route> 
        <Route  path="/location" element={<MapClassComponent />} > </Route> 
        <Route  path="/user/location/:id" element={<LocationMap />} > </Route> 
      
    </Routes>
    </HashRouter>
    </SharedProvider>
  </div>
     
  );
}

export default App;
